/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../../api/contract';
import '../../../common/currency';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "cash": {
        "nested": {
          "grantly": {
            "nested": {
              "api": {
                "nested": {
                  "PreAuthorizePaymentResponse": {
                    "fields": {
                      "preAuthToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "eligibleDiscounts": {
                        "type": "squareup.cash.grantly.api.Discount",
                        "id": 2,
                        "rule": "repeated"
                      },
                      "autoSelectedDiscount": {
                        "type": "squareup.cash.grantly.api.Discount",
                        "id": 3,
                        "rule": "optional"
                      },
                      "metadata": {
                        "type": "squareup.cash.api.ResponseMetadata",
                        "id": 4,
                        "rule": "optional"
                      },
                      "result": {
                        "type": "squareup.cash.grantly.api.PreAuthorizePaymentResponse.Result",
                        "id": 5,
                        "rule": "optional"
                      },
                      "preAuthorizationData": {
                        "type": "squareup.cash.grantly.api.PreAuthorizationData",
                        "id": 6,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "Result": {
                        "values": {
                          "SUCCESS": 1,
                          "FAILURE": 2,
                          "RETRYABLE_FAILURE": 3
                        }
                      }
                    }
                  },
                  "PreAuthorizationData": {
                    "fields": {
                      "preAuthToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "required"
                      },
                      "eligibleDiscounts": {
                        "type": "squareup.cash.grantly.api.Discount",
                        "id": 2,
                        "rule": "repeated"
                      },
                      "autoSelectedDiscount": {
                        "type": "squareup.cash.grantly.api.Discount",
                        "id": 3,
                        "rule": "optional"
                      },
                      "eligibleLoanOptions": {
                        "type": "squareup.cash.grantly.api.LoanOption",
                        "id": 4,
                        "rule": "repeated"
                      },
                      "orderId": {
                        "type": "string",
                        "id": 5,
                        "rule": "optional"
                      }
                    }
                  },
                  "LoanOption": {
                    "fields": {
                      "loanType": {
                        "type": "squareup.cash.grantly.api.LoanOption.LoanType",
                        "id": 1,
                        "rule": "optional"
                      },
                      "paymentSchedule": {
                        "type": "squareup.cash.grantly.api.PaymentSchedule",
                        "id": 2,
                        "rule": "repeated"
                      },
                      "tilaData": {
                        "type": "squareup.cash.grantly.api.TilaData",
                        "id": 3,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "LoanType": {
                        "values": {
                          "PAY_IN_FOUR": 1,
                          "PAY_IN_TWO": 2
                        }
                      }
                    }
                  },
                  "TilaData": {
                    "fields": {
                      "dateBorrowed": {
                        "type": "int64",
                        "id": 1,
                        "rule": "optional"
                      },
                      "amountFinanced": {
                        "type": "squareup.common.Money",
                        "id": 2,
                        "rule": "optional"
                      },
                      "financeCharge": {
                        "type": "squareup.common.Money",
                        "id": 3,
                        "rule": "optional"
                      },
                      "totalOfPayments": {
                        "type": "squareup.common.Money",
                        "id": 4,
                        "rule": "optional"
                      },
                      "aprBps": {
                        "type": "int64",
                        "id": 5,
                        "rule": "optional"
                      },
                      "loanDurationDays": {
                        "type": "int32",
                        "id": 6,
                        "rule": "optional"
                      },
                      "flatFeeAsDailyFeeBps": {
                        "type": "int64",
                        "id": 7,
                        "rule": "optional"
                      },
                      "finalDueDate": {
                        "type": "int64",
                        "id": 8,
                        "rule": "optional"
                      },
                      "amountDueOnDueDate": {
                        "type": "squareup.common.Money",
                        "id": 9,
                        "rule": "optional"
                      },
                      "lateFeeGracePeriodDays": {
                        "type": "int32",
                        "id": 10,
                        "rule": "optional"
                      },
                      "lateFeeAmount": {
                        "type": "squareup.common.Money",
                        "id": 11,
                        "rule": "optional"
                      },
                      "setupFee_BPS": {
                        "type": "int64",
                        "id": 12,
                        "rule": "optional"
                      },
                      "lender": {
                        "type": "squareup.cash.grantly.api.LoanParty",
                        "id": 13,
                        "rule": "optional"
                      },
                      "borrower": {
                        "type": "squareup.cash.grantly.api.LoanParty",
                        "id": 14,
                        "rule": "optional"
                      }
                    }
                  },
                  "LoanParty": {
                    "fields": {
                      "address": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "name": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "PaymentSchedule": {
                    "fields": {
                      "paymentNumber": {
                        "type": "int32",
                        "id": 1,
                        "rule": "optional"
                      },
                      "isOptional": {
                        "type": "bool",
                        "id": 2,
                        "rule": "optional"
                      },
                      "paymentDate": {
                        "type": "int64",
                        "id": 3,
                        "rule": "optional"
                      },
                      "amount": {
                        "type": "squareup.common.Money",
                        "id": 4,
                        "rule": "optional"
                      }
                    }
                  },
                  "Discount": {
                    "fields": {
                      "discountKey": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "flatDiscount": {
                        "type": "uint32",
                        "id": 2,
                        "rule": "optional"
                      },
                      "bps": {
                        "type": "uint32",
                        "id": 3,
                        "rule": "optional"
                      },
                      "description": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      },
                      "maxOneTimeDiscount": {
                        "type": "uint32",
                        "id": 5,
                        "rule": "optional"
                      },
                      "maxDailyDiscount": {
                        "type": "uint32",
                        "id": 6,
                        "rule": "optional"
                      },
                      "maxUsageCount": {
                        "type": "uint32",
                        "id": 7,
                        "rule": "optional"
                      },
                      "totalDiscountAmount": {
                        "type": "uint32",
                        "id": 8,
                        "rule": "optional"
                      },
                      "discountToken": {
                        "type": "string",
                        "id": 9,
                        "rule": "optional"
                      },
                      "allowedAuthorizationChannels": {
                        "type": "squareup.cash.grantly.api.Discount.AuthorizationChannel",
                        "id": 10,
                        "rule": "repeated"
                      },
                      "maxCampaignDiscount": {
                        "type": "uint32",
                        "id": 11,
                        "rule": "optional"
                      },
                      "targetedCustomers": {
                        "type": "string",
                        "id": 12,
                        "rule": "repeated"
                      },
                      "inAppOnly": {
                        "type": "bool",
                        "id": 13,
                        "rule": "optional"
                      },
                      "minTransactionAmount": {
                        "type": "uint32",
                        "id": 14,
                        "rule": "optional"
                      },
                      "paymentMethodTarget": {
                        "type": "squareup.cash.grantly.api.Discount.PaymentMethodTarget",
                        "id": 15,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "AuthorizationChannel": {
                        "values": {
                          "IN_PERSON": 1,
                          "ONLINE": 2,
                          "IN_APP": 3
                        }
                      },
                      "PaymentMethodTarget": {
                        "values": {
                          "UNKNOWN": 1,
                          "CASH_APP_PAY_ONLY": 2,
                          "AGNOSTIC": 3
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.PreAuthorizePaymentResponse && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.PreAuthorizePaymentResponse?.nested?.Result && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.PreAuthorizationData && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.LoanOption && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.LoanOption?.nested?.LoanType && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.TilaData && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.LoanParty && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.PaymentSchedule && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.Discount && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.Discount?.nested?.AuthorizationChannel && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.Discount?.nested?.PaymentMethodTarget) {
  $root.addJSON(jsonData);
}

/**
 * The following messages are copies of merbro-defined protos to resolve
 *   #cash-inc-5056_dependency-update-blocked-in-grantly
 * Copy of https://prototype.sqprod.co/#/docs/squareup.cash.merbro.api.PreAuthorizePaymentResponse
 *
 * SOURCE PreAuthorizePaymentResponse @ squareup/cash/grantly/api/preauthorize_payment_response.proto at 15:1
 */
export const PreAuthorizePaymentResponse = $root.lookupType('squareup.cash.grantly.api.PreAuthorizePaymentResponse');
fixType(PreAuthorizePaymentResponse, {
  preAuthorizationData: {
    required: true
  }
});
Builder.createAndAttachToType(PreAuthorizePaymentResponse);
/**
 * https://prototype.sqprod.co/#/docs/squareup.cash.merbro.api.Result
 *
 * SOURCE Result @ squareup/cash/grantly/api/preauthorize_payment_response.proto at 24:3
 */
PreAuthorizePaymentResponse.Result = $root.lookupEnum('squareup.cash.grantly.api.PreAuthorizePaymentResponse.Result').values;
/**
 * https://prototype.sqprod.co/#/docs/squareup.cash.merbro.api.PreAuthorizationData
 *
 * SOURCE PreAuthorizationData @ squareup/cash/grantly/api/preauthorize_payment_response.proto at 32:1
 */
export const PreAuthorizationData = $root.lookupType('squareup.cash.grantly.api.PreAuthorizationData');
fixType(PreAuthorizationData);
Builder.createAndAttachToType(PreAuthorizationData);
/**
 * https://prototype.sqprod.co/#/docs/squareup.cash.merbro.api.loans.LoanOption
 *
 * SOURCE LoanOption @ squareup/cash/grantly/api/preauthorize_payment_response.proto at 41:1
 */
export const LoanOption = $root.lookupType('squareup.cash.grantly.api.LoanOption');
fixType(LoanOption, {
  paymentSchedule: {
    required: true
  },
  tilaData: {
    required: true
  }
});
Builder.createAndAttachToType(LoanOption);
/**
 * https://prototype.sqprod.co/#/docs/squareup.cash.merbro.api.loans.LoanOption.LoanType
 *
 * SOURCE LoanType @ squareup/cash/grantly/api/preauthorize_payment_response.proto at 43:3
 */
LoanOption.LoanType = $root.lookupEnum('squareup.cash.grantly.api.LoanOption.LoanType').values;
/**
 * https://prototype.sqprod.co/#/docs/squareup.cash.merbro.api.loans.TilaData
 *
 * SOURCE TilaData @ squareup/cash/grantly/api/preauthorize_payment_response.proto at 53:1
 */
export const TilaData = $root.lookupType('squareup.cash.grantly.api.TilaData');
fixType(TilaData, {
  dateBorrowed: {
    required: true
  },
  amountFinanced: {
    required: true
  },
  financeCharge: {
    required: true
  },
  totalOfPayments: {
    required: true
  },
  aprBps: {
    required: true
  },
  loanDurationDays: {
    required: true
  },
  flatFeeAsDailyFeeBps: {
    required: true
  },
  finalDueDate: {
    required: true
  },
  amountDueOnDueDate: {
    required: true
  },
  lateFeeGracePeriodDays: {
    required: true
  },
  lateFeeAmount: {
    required: true
  },
  setupFee_BPS: {
    required: true
  },
  lender: {
    required: true
  },
  borrower: {
    required: true
  }
});
Builder.createAndAttachToType(TilaData);
/**
 * SOURCE LoanParty @ squareup/cash/grantly/api/preauthorize_payment_response.proto at 85:1
 */
export const LoanParty = $root.lookupType('squareup.cash.grantly.api.LoanParty');
fixType(LoanParty, {
  address: {
    required: true
  },
  name: {
    required: true
  }
});
Builder.createAndAttachToType(LoanParty);
/**
 * https://prototype.sqprod.co/#/docs/squareup.cash.merbro.api.loans.PaymentSchedule
 *
 * SOURCE PaymentSchedule @ squareup/cash/grantly/api/preauthorize_payment_response.proto at 92:1
 */
export const PaymentSchedule = $root.lookupType('squareup.cash.grantly.api.PaymentSchedule');
fixType(PaymentSchedule, {
  paymentNumber: {
    required: true
  },
  isOptional: {
    required: true
  },
  paymentDate: {
    required: true
  },
  amount: {
    required: true
  }
});
Builder.createAndAttachToType(PaymentSchedule);
/**
 * https://prototype.sqprod.co/#/docs/squareup.cash.merbro.api.Discount
 *
 * SOURCE Discount @ squareup/cash/grantly/api/preauthorize_payment_response.proto at 100:1
 */
export const Discount = $root.lookupType('squareup.cash.grantly.api.Discount');
fixType(Discount);
Builder.createAndAttachToType(Discount);
/**
 * https://prototype.sqprod.co/#/docs/squareup.cash.merbro.api.AuthorizationChannel
 *
 * SOURCE AuthorizationChannel @ squareup/cash/grantly/api/preauthorize_payment_response.proto at 118:3
 */
Discount.AuthorizationChannel = $root.lookupEnum('squareup.cash.grantly.api.Discount.AuthorizationChannel').values;
/**
 * https://prototype.sqprod.co/#/docs/squareup.cash.merbro.api.Discount.PaymentMethodTarget
 *
 * SOURCE PaymentMethodTarget @ squareup/cash/grantly/api/preauthorize_payment_response.proto at 125:3
 */
Discount.PaymentMethodTarget = $root.lookupEnum('squareup.cash.grantly.api.Discount.PaymentMethodTarget').values;